import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TableColumnWidthInfo } from '@devexpress/dx-react-grid';

import { bundlesLoaded } from './bundlesSlice';
import { statusSet } from './productionComponentInstancesSlice';
import { truckloadDeleted } from './truckloadsSlice';

interface TruckloadGridState {
  readonly projectGuidFilter: string | null;
  readonly expandedRows: string[];
  readonly checkedRows: readonly string[];
  readonly userColumnWidths: TableColumnWidthInfo[] | null;
}

const initialState: TruckloadGridState = {
  projectGuidFilter: null,
  expandedRows: [],
  checkedRows: [],
  userColumnWidths: null,
};

const truckloadGridSlice = createSlice({
  name: 'truckloadGrid',
  initialState,
  reducers: {
    setProjectGuidFilter: (state, action: PayloadAction<string | null>) => {
      state.projectGuidFilter = action.payload;
      state.checkedRows = [];
      state.expandedRows = [];
    },
    expandRows: (state, action: PayloadAction<readonly string[]>) => {
      for (const rowId of action.payload) {
        if (state.expandedRows.includes(rowId)) continue;
        state.expandedRows.push(rowId);
      }
    },
    collapseRows: (state, action: PayloadAction<readonly string[]>) => {
      state.expandedRows = state.expandedRows.filter((expandedRow) => !action.payload.includes(expandedRow));
    },
    checkRows: (state, action: PayloadAction<readonly string[]>) => {
      for (const rowId of action.payload) {
        if (state.checkedRows.includes(rowId)) continue;
        state.checkedRows.push(rowId);
      }
    },
    uncheckRows: (state, action: PayloadAction<readonly string[]>) => {
      state.checkedRows = state.checkedRows.filter((checkedRow) => !action.payload.includes(checkedRow));
    },
    setUserColumnWidths: (state, action: PayloadAction<TableColumnWidthInfo[]>) => {
      state.userColumnWidths = action.payload;
    },
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(bundlesLoaded, (state) => {
      state.checkedRows = [];
    });
    builder.addCase(statusSet, (state) => {
      state.checkedRows = [];
    });
    builder.addCase(truckloadDeleted, (state) => {
      state.checkedRows = [];
    });
  },
});

export const { setProjectGuidFilter, expandRows, collapseRows, checkRows, uncheckRows, setUserColumnWidths } =
  truckloadGridSlice.actions;
export const truckloadGrid = truckloadGridSlice.reducer;
